// components/MRunsLogo.js
import React from 'react';
import { Box } from '@mui/material';

// The component now accepts a `color` prop with a default fall color
export default function MRunsLogo({ color = '#D97706' }) {
    return (
        <Box
            component="svg"
            viewBox="0 0 480 120" 
            sx={{
                width: '100%',
                maxWidth: '150px',
                height: 'auto',
                // Define a CSS variable from the color prop
                '--logo-color': color,
            }}
            xmlns="http://www.w3.org/2000/svg"
        >
            <style>
                {`
                  @keyframes glowPulse {
                    /* Use the CSS variable for the animation color */
                    0%, 100% { filter: brightness(1) drop-shadow(0 0 6px var(--logo-color)); }
                    50% { filter: brightness(1.2) drop-shadow(0 0 16px var(--logo-color)); }
                  }
                  @keyframes letterIn {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                  }
                  .glow { animation: glowPulse 2.5s ease-in-out infinite; }
                  .text-anim { opacity: 0; animation: letterIn 0.6s forwards; }
                `}
            </style>

            {/* MRuns.com Text - Centered */}
            <text
                x="50%"
                y="80"
                textAnchor="middle"
                fontFamily="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"
                fontWeight="900"
                fontSize="60"
            >
                <tspan fill="#1A1A1A" className="text-anim" style={{ animationDelay: '0.2s' }}>M</tspan>
                <tspan fill="#1A1A1A" className="text-anim" style={{ animationDelay: '0.3s' }}>R</tspan>
                <tspan fill="#1A1A1A" className="text-anim" style={{ animationDelay: '0.4s' }}>u</tspan>
                <tspan fill="#1A1A1A" className="text-anim" style={{ animationDelay: '0.5s' }}>n</tspan>
                <tspan fill="#1A1A1A" className="text-anim" style={{ animationDelay: '0.6s' }}>s</tspan>
                {/* Use the color prop for the fill */}
                <tspan fill={color} className="text-anim glow" style={{ animationDelay: '0.8s' }}>.com</tspan>
            </text>
        </Box>
    );
}
